import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=cda2eff0&scoped=true&"
import script from "./Purchase.vue?vue&type=script&lang=ts&"
export * from "./Purchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda2eff0",
  null
  
)

export default component.exports